import axios from 'axios';

axios.getAddressComponents = (event_value) => {

  let url = 'https://maps.googleapis.com/maps/api/geocode/json';
  let options = {
    params: {
      latlng: event_value.latLng.lat() + ',' + event_value.latLng.lng(),
      key: 'AIzaSyCu1N9tNE8mEh_u4yI3SCOn3M_gV3CgL5E'
    }
  };

  return axios.get(url, options)
    .then(response => {
      return response.data.results[0].address_components;
    });
};

export default axios;